import { useEffect, useState } from "react";
import heroImage from "../../../../assets/images/homeImage2.jpg";
import Loader from "../../../../common/Loader";
import api from "../../../../configs/api";

export default function Hero() {

  const [HeroData, setHeroData] = useState({});

  const [isLoading, setIsLoading] = useState(true);

  const setHeroDataFn = async () => {
    try {
      const HeroData = await api.get("/CMS/home-data");
      setHeroData(HeroData?.data?.homeData);
      setIsLoading(false);
    } catch (error) {
      console.error("set theme error: ", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setHeroDataFn();
  }, []);

  return (
    <section>
      <div className='flex flex-col laptopS:flex-row laptopS:pt-28 justify-between'>
        {/* Image */}
        {isLoading ? (
          <div className='w-[50rem] flex justify-center items-center'>
            <Loader isFullScreen={false} />
          </div>
        ) : (
          <div className='relative'>
            <img
              src={
                !isLoading && !HeroData?.mainImage
                  ? heroImage
                  : HeroData?.mainImage
              }
              alt='Placeholder'
              className='laptopS:rounded-r-[35%] z-10 w-screen laptopS:w-[50rem] h-[30rem] object-cover'
            />
            <div className='hidden laptopS:block absolute -rotate-[7deg] top-[-1.625rem] left-[5rem] -z-10 bg-primary w-[36rem] h-[28rem] rounded-r-[35%]'></div>
          </div>
        )}

        {/* Text */}
        <div className='px-6 laptopS:me-10 mt-16 text-end'>
          <h1 className='text-5xl laptopS:text-6xl font-custom-600 mb-4 max-w-[100rem]'>
            {!isLoading && !HeroData?.mainTitle
              ? "نعمل بأعلى معايير الجودة لنحقق آمالكم"
              : HeroData?.mainTitle}
          </h1>
          <p className='laptopS:text-2xl mb-8'>
            {!isLoading && !HeroData?.mainSubTitle
              ? "شبكة متكاملة لتقديم الخدمات التأهيلية والرعاية النهارية"
              : HeroData?.mainSubTitle}
          </p>
        </div>
      </div>
      <div className='relative flex justify-center flex-col items-center'>
        <div className='w-full'>
          <div className='bg-primary h-1 my-32 mx-10' />
        </div>
        <span className='absolute select-none flex justify-center text-center bg-primary px-4 py-2 rounded-custom-14 text-white text-custom-28 w-56 h-14'>
          أقرأ المزيد
        </span>
      </div>
    </section>
  );
}
